import "bijou/base";

const getPrimaryQuestionInfo = (element) => {
  const consolidatedPrimaryQuestion = $(element).find(".on").eq(0);
  const consolidatedQuestionName =
    consolidatedPrimaryQuestion.attr("data-question");

  const consolidatedQuestionsGroup = consolidatedPrimaryQuestion.next(
    ".consolidated-questions",
  );

  return [consolidatedQuestionName, consolidatedQuestionsGroup];
};

const containsVisibleQuestions = (element) => {
  return element[0] && element[0].querySelectorAll(".on").length > 0;
};

const unCheckInputs = (element) => {
  element
    .find("input:checked")
    .prop("checked", false)
    .trigger("change")
    .removeClass("checkbox-checked");
};

const checkNoButtons = (element) => {
  element
    .find(".on")
    .find("input[value = 'no']")
    .prop("checked", true)
    .trigger("change");
};

const toggleDefaultNo = (element, toggle) => {
  element
    .find("input.consolidated_no_default")
    .prop("checked", toggle)
    .trigger("change");
};

const hideDefaultNo = (element) => {
  element.find("input.consolidated_no_default").parent("label").hide();
};

const toggleConsolidatedQuestionsGroup = () => {
  const primaryQuestionGroups = $(".primary-question");
  if (primaryQuestionGroups.length > 0) {
    primaryQuestionGroups.each(function () {
      const [, consolidatedQuestionsGroup] = getPrimaryQuestionInfo(this);
      if (containsVisibleQuestions(consolidatedQuestionsGroup)) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  }
};

const toggleDynamicSecondaryText = (questionName, toggleFlag) => {
  if ($(".primary-question").length > 0) {
    const listElement = $(`.dynamic-secondary-text li.${questionName}`);
    if (listElement.length > 0) {
      if (toggleFlag) {
        listElement.eq(0).show();
      } else {
        listElement.eq(0).hide();
      }
    }
  }
};

const initConsolidatedQuestions = () => {
  const primaryQuestionGroups = $(".primary-question");
  if (primaryQuestionGroups.length > 0) {
    primaryQuestionGroups.each(function () {
      const [consolidatedQuestionName, consolidatedQuestionsGroup] =
        getPrimaryQuestionInfo(this);

      if ($(`#${consolidatedQuestionName}_yes:checked`).val() !== "yes") {
        consolidatedQuestionsGroup.hide();
      }

      // If the no button is checked but not all sub-questions are answered, require the user to answer them again
      if ($(`#${consolidatedQuestionName}_no:checked`).val() === "no") {
        if (
          consolidatedQuestionsGroup.find(
            ".on input[type='radio'][value='no']:not(:checked)",
          ).length > 0
        ) {
          $(`#${consolidatedQuestionName}_no:checked`).prop("checked", false);
          unCheckInputs(consolidatedQuestionsGroup);
        }
      }

      if (containsVisibleQuestions(consolidatedQuestionsGroup)) {
        $(this).show();
        hideDefaultNo(consolidatedQuestionsGroup);
      } else {
        $(this).hide();
        unCheckInputs(consolidatedQuestionsGroup);
      }

      // Trigger validation when we change an input in the group
      consolidatedQuestionsGroup.find("input").on("change", function () {
        $("#js-questionnaire form")
          .validate()
          .element($(`input[name=${consolidatedQuestionName}]`));
      });

      $(`#${consolidatedQuestionName}_yes`).change(function () {
        consolidatedQuestionsGroup.show();
        toggleDefaultNo(consolidatedQuestionsGroup, false);
        unCheckInputs(consolidatedQuestionsGroup);
      });

      $(`#${consolidatedQuestionName}_no`).change(function () {
        consolidatedQuestionsGroup.hide();
        unCheckInputs(consolidatedQuestionsGroup);
        toggleDefaultNo(consolidatedQuestionsGroup, true);
        checkNoButtons(consolidatedQuestionsGroup);
      });
    });
  }
};

export {
  initConsolidatedQuestions,
  toggleConsolidatedQuestionsGroup,
  toggleDynamicSecondaryText,
};

$(() => {
  initConsolidatedQuestions();
});
